// CRM 2.0 · M12-F4: what one scanned QR shows on its own (single scan page and the global scanner): the agreement,
// the copy and its status, then the values of that page (live from the Sales App), masked unless the role may see them.
import React from "react";
import cls from "./Crm2Verify.module.css";
import SheetGroups from "./SheetGroups";

function ScanResult({ scan }) {
  return (
    <div className={cls.stack}>
      {scan.isOld && <p className={`${cls.notice} ${cls.noticeOld}`}>{scan.notice}</p>}
      {scan.signed && <p className={cls.notice}>Every QR page of this copy is checked.</p>}
      <div className={cls.card}>
        <div className={cls.cardTop}>
          <div>
            <h2 className={cls.name}>{scan.customer || "—"}</h2>
            <p className={cls.unit}>{scan.unit}</p>
          </div>
          <span className={`${cls.tag} ${scan.isOld ? "" : cls.tagDark}`}>Copy {scan.copyNo}</span>
        </div>
        <p className={cls.meta}>Printed {scan.printedOn}{scan.isOld ? " · old copy" : " · current copy"}</p>
      </div>
      <div className={cls.sheetHead}>
        <h4 className={cls.sheetTitle}>{scan.title}</h4>
        {scan.summary && <p className={cls.sheetSub}>{scan.summary}</p>}
      </div>
      <SheetGroups groups={scan.groups} />
      {!scan.groups.length && <div className={cls.empty}>No system fields on this page.</div>}
      {scan.masked && <p className={cls.masked}>PAN, Aadhaar, mobile and email are hidden for your role.</p>}
      <p className={cls.meta}>These are the values in the Sales App now. Compare them with the printed page.</p>
    </div>
  );
}

export default ScanResult;
